import React, { useEffect, useState } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { serverUrl } from "../../config";
import CompanyappLoader from "../../partials/companyappLoader";
import Error from "../../partials/error";

// UI components
import GlobeIconUrl from "../../assets/clients/rhg/globe.svg";
import OpenIconUrl from "../../assets/clients/rhg/open.svg";
import LoadingUrl from "../../assets/clients/rhg/loading.svg";
import MoreIconUrl from "../../assets/clients/rhg/more.svg";

const errorMessage = "An error occurred. Please try again or contact system administrator."

export default function RHGMap(props) {
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  // hooks
  const permissions = useSelector((state) => state).permissionsReducer
    .permissions;

  useEffect(() => {
    if (permissions.access_map) {
      setError(false);
      setLoading(false);
    } else {
      setError(true);
      setLoading(false);
    }
  }, [permissions]);

  return (
    <>
      {isError ? (
        <Error message={errorMessage} />
      ) : (
        <main className="map screen">
          {isLoading ? (
            <CompanyappLoader />
          ) : (
            <>
              <iframe
                title="Global Portfolio"
                src={`../../rhg-global-map.html?serverUrl=${serverUrl}&globeIconUrl=${GlobeIconUrl}&openIconUrl=${OpenIconUrl}&loadingIconUrl=${LoadingUrl}&moreIconUrl=${MoreIconUrl}`}
                width="100%"
                height="100%"
              />
            </>
          )}
        </main>
      )}
    </>
  );
}
